import { isBrowser } from 'common/utils'

const LOCALSTORAGE_GIFANIMATION = 'listGifAnimation'
const initialState: boolean = true

// action types
const SET = 'list/isGifAnimation/SET'

// action creators
export const setGifAnimationFromStorage = () => {
  let animation = true
  if (isBrowser && localStorage) {
    animation = (localStorage.getItem(LOCALSTORAGE_GIFANIMATION) || 'on') === 'on'
  }
  return { animation, type: SET }
}

export const storeGifAnimation = (on: boolean) => {
  if (isBrowser && localStorage) {
    localStorage.setItem(LOCALSTORAGE_GIFANIMATION, on ? 'on' : 'off')
  }
  return { type: SET, animation: on }
}

// reducer
export default (state: boolean = initialState, action) => {
  switch (action.type) {
    case SET:
      return action.animation
    default:
      return state
  }
}
